// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"00dc0a3c","845":"503fadd2"}[chunkId] + ".chunk.js";
};